import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAssessmentReviewListRequest_ACCESSOR, setCompanyName } from "../../../../Redux/Slices/Accessor/accessorSlice";

import MainLayout from "Layouts/Main";
import NormalTable from "Components/NormalTable";
import ProgressBar from "Components/Progressbar";
import Button from "Components/Button";
import moment from "moment";
import InputBox from "Components/InputBox";
import InstructionsModalForAssessor from "../../../../Components/InstructionsModal/InstructionsModalForAssessor";

const AssessmentReview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [assementReviewList, setAssementReviewList] = useState([]);
  const [sort, setSort] = useState({ sortBy: null, sortOrder: 0 });
  const [showInstructions, setShowInstructions] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const isLoading = useSelector((state) => state.accessor.isLoading);

  useEffect(() => {
    getAssessmentReviewListRequest_ACCESSOR_(currentPage, "");
  }, [sort, currentPage, search]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const assessmentSubmittedHead = [
    { label: "S.No", isSort: false, key: "sno" },
    { label: "Company Name", isSort: true, key: "company_name" },
    { label: "Reference Number", isSort: true, key: "reference_name", headerStyle: { paddingInline: "15px" } },
    { label: "Due Date", isSort: true, key: "due_date" },
    { label: "Assessment Date", isSort: true, key: "start_date" },
    { label: "Completion Status", isSort: false, key: "completionStatus" },
  ];

  const getDisplayedIndex = (currentPage, index) => {
    return (currentPage - 1) * 8 + index + 1;
  };

  const getAssessmentReviewListRequest_ACCESSOR_ = (page, filter) => {
    dispatch(
      getAssessmentReviewListRequest_ACCESSOR({
        page,
        filter,
        search,
        sortBy: sort.sortOrder === 1 ? "ASC" : "DESC",
        orderBy: sort.sortBy,
        callBack: getAssessmentReviewListRequestCB_ACCESSOR,
      })
    );
  };

  const getAssessmentReviewListRequestCB_ACCESSOR = (data) => {
    setTotalPages(data?.data?.pageMeta?.totalPages);
    setAssementReviewList(data?.data?.data);
  };

  const handlePageChange = async (page) => {
    await setCurrentPage(page);
    await getAssessmentReviewListRequest_ACCESSOR_(page, "");
  };

  const handleNavigation = (item) => {
    dispatch(setCompanyName(item?.company_name));
    if (item?.is_reviewed) {
      navigate(`/assessment-review/view-assessment/preview/${item.assessment_id}`, {
        state: { assessment_id: item?.assessment_id, reviewed: true, approval_status: item?.approval_status, company_name: item?.company_name, },
      });
    } else {
      setSelectedItem(item);
      if (!item?.completion_percentage || item?.completion_percentage === 0) {
        setShowInstructions(true);
      } else {
        navigate(`/assessment-review/view-assessment/${item.assessment_id}`, {
          state: {
            company_name: item?.company_name,
            assessment_id: item?.assessment_id,
          },
        });
      }
    }
  };

  const handleContinue = () => {
    if (!selectedItem) return;
    setShowInstructions(false);
    navigate(`/assessment-review/view-assessment/${selectedItem.assessment_id}`, {
      state: {
        company_name: selectedItem?.company_name,
        assessment_id: selectedItem?.assessment_id,
      },
    });
  };

  return (
    <MainLayout>
      <InstructionsModalForAssessor
        isOpen={showInstructions}
        onClose={() => setShowInstructions(false)}
        onContinue={handleContinue}
        Button={Button}
      />

      <div className="assementreview-container mt-3 ps-4 ms-2">
        <div className="d-flex justify-content-between align-items-center">
          <label className="assessmentSubmittedTitle">Conduct Assessment</label>
          <div className="me-3">
            <InputBox
              name="search"
              isSearch={true}
              placeholder="Search"
              value={search}
              onChange={(e) => handleSearch(e)}
              inputStyle={{ width: "277px" }}
            />
          </div>
        </div>

        <div>
          <NormalTable
            loading={isLoading === "loading"}
            headers={assessmentSubmittedHead}
            sort={sort}
            setSort={setSort}
            currentPage={currentPage}
            noDataColspan={9}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            customStyle={{
              customTableHeaderContainer: "customTableHeader",
              customHeaderTitle: "customHeaderStartTitle",
              customTable: "customReviewTable",
              customTableContainer: "customTableContainer",
            }}
            noDataLabel={assementReviewList?.length === 0}
          >
            {assementReviewList?.map((item, index) => {
              const buttonTitle =
                !item?.completion_percentage || item?.completion_percentage === 0
                  ? "Start Assessment"
                  : item?.completion_percentage > 0 && !item?.is_reviewed && item?.approval_status !== 3
                  ? "Continue Assessment"
                  : item?.completion_percentage > 0 && item?.approval_status === 3
                  ? "Continue Again"
                  : "View Assessment";

              return (
                <tr key={index}>
                  <td><div className="TableDivisionStart mx-3 mt-1">{getDisplayedIndex(currentPage, index)}</div></td>
                  <td><div className="TableDivisionStart ms-2">{item?.company_name ?? "-"}</div></td>
                  <td><div className="TableDivisionStart ms-2" style={{ paddingInline: "15px" }}>{item?.reference_name ?? "-"}</div></td>
                  <td><div className="TableDivisionStart ms-2">{moment.utc(item?.due_date).format("DD/MM/YYYY")}</div></td>
                  <td><div className="TableDivisionStart ms-2">{moment.utc(item?.start_date).format("DD/MM/YYYY")}</div></td>
                  <td>
                    <div className="TableDivisionStart flex-column ms-2 me-3">
                      <div>{item?.completion_percentage}%</div>
                      <ProgressBar
                        completedPercentage={item?.completion_percentage}
                        fillColor={item?.completion_percentage === 100 ? "#01A63B" : "#1F2155"}
                        ProgressBarStyle={{ height: "5px" }}
                      />
                    </div>
                  </td>
                  <td>
                    <div className="TableDivisionStart">
                      <Button
                        title={buttonTitle}
                        titleStyle={{ color: "#ffffff", fontSize: "14px" }}
                        buttonStyle={{ minWidth: "200px" }}
                        modifyClassName={true}
                        className="viewScoreButton"
                        onClick={() => handleNavigation(item)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </NormalTable>
        </div>
      </div>
    </MainLayout>
  );
};

export default AssessmentReview;
